<template>
  <div>
    <div v-if="!loadStatus">
      <Skeleton width="100%" height="3.5rem" v-for="i in 15" :key="i" />
    </div>

    <template v-if="loadStatus">
      <div v-if="groupOrdersList.length > 0" class="order-list">
        <vue-good-table
          :columns="groupOrderColumns"
          :rows="groupOrdersList"
          styleClass="vgt-table striped"
        >
          <template slot="table-column" slot-scope="props">
            <span
              v-if="props.column.field == 'createdAt'"
              style="display: flex; justify-content: center;"
            >
              {{ props.column.label }}
            </span>
          </template>
          <template slot="table-row" slot-scope="groupOrdersList">
            <span v-if="groupOrdersList.column.field === 'createdAt'">
              <span class="gorder-list-date">{{
                defaultFormatAndParse(groupOrdersList.row.createdAt)
              }}</span>
            </span>
            <span v-else-if="groupOrdersList.column.field === 'uuid'">
              <span
                >{{ groupOrdersList.row.name }}
                <!-- {{ groupOrdersList.row.uuid | splitUID }} --></span
              >
            </span>
            <span v-else-if="groupOrdersList.column.field === 'status'">
              <span>
                {{
                  currentState(groupOrdersList.row.status) | Capitalize
                }}</span
              >
            </span>
            <span v-else-if="groupOrdersList.column.field === 'submissions'">
              <span class="gorder-list-submission">
                {{ groupOrdersList.row.submissions }}</span
              >
            </span>
            <span
              v-else-if="groupOrdersList.column.field === 'detailsUrl'"
              class="flex items-center gap-5"
            >
              <span
                class="hoverable-text bold"
                @click="
                  $router.push(`/redemption/details/${groupOrdersList.row.id}`)
                "
                >View Details</span
              >
              <button
                class="block w-max delete-button"
                :class="{ isDisabled: !groupOrdersList.row.isDeletable }"
                :disabled="!groupOrdersList.row.isDeletable"
                @click="handleShowDeleteModal(groupOrdersList.row)"
              >
                <img src="@/assets/trash.svg" alt="" class="w-4.5" />
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
      <div v-else>
        <GroupOrderListZeroState />
      </div>
    </template>
    <Pagination
      :total-items="totalRecords"
      :page="serverParams.page"
      :items-per-page="serverParams.perPage"
      @page-change="pageChange"
      @perPageChange="handlePerPageChange"
    />

    <DeleteGroupOrderModal
      :showFooter="true"
      :modalName="deleteGroupOrderModal"
      :buttonLabel="'Delete'"
      v-show="isModalActive"
      @confirmAction="confirmDeleteGroupOrder"
      colorVariation="secondary"
      :isConfirmButtonDisabled="deletingRedemptionOrder"
      width="550px"
    >
      <template slot="header">
        Delete Redemption Page
      </template>
      <template slot="body">
        <div class="margin-top-1">
          <span>
            Are you sure you want to delete
            <span class="capitalize">{{ selectedGroupOrder.name }}</span
            >?
          </span>
          <div
            class="flex items-center justify-center gap-0.5 gorder-delete__info"
          >
            <img src="@/assets/warning-dark.svg" alt="" />
            <p class="font-bold relative -top-0.5">
              This action cannot be reversed.
            </p>
          </div>
        </div>
      </template>
    </DeleteGroupOrderModal>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { progressStatus } from '../../helpers'
import { VueGoodTable } from 'vue-good-table'
import DateFns from '@/mixins/DateFns'

export default {
  name: 'GroupOrderActiveList',
  mixins: [DateFns],

  watch: {
    searchTerm(newVal) {
      if (newVal) {
        this.searchGroupOrders(newVal)
      } else {
        this.getGroupOrdersList({
          page: 1,
          perPage: this.serverParams.perPage,
          filter: 'active'
        })
      }
    }
  },
  components: {
    VueGoodTable,
    GroupOrderListZeroState: () =>
      import('@/components/GroupOrder/GroupOrderListZeroState'),
    Skeleton: () => import('@/components/Universal/Skeleton'),
    Pagination: () => import('@/components/Universal/Pagination'),
    DeleteGroupOrderModal: () => import('@/components/Universal/RemoveModal')
  },
  created() {
    this.$store.dispatch('globalTracking/changeSearchTerm', '')
    this.getGroupOrdersList({
      page: 1,
      perPage: this.serverParams.perPage,
      nameOrEmail: '',
      filter: 'active'
    })
    if (
      this.userProfile.roles.includes('team_owner') &&
      !Object.keys(this.currentSubscription).length
    ) {
      this.$store.dispatch('billing/getCurrentSubscription')
    }
  },
  data() {
    return {
      deleteGroupOrderModal: 'groupOrderDeleteModal',
      serverParams: {
        page: 0,
        perPage: 50
      },
      groupOrderColumns: [
        {
          label: 'Created',
          field: 'createdAt',
          textAlign: 'center',
          width: '160px'
        },
        {
          label: 'Redemption Page',
          field: 'uuid'
        },
        {
          label: 'Creator',
          field: 'createdBy.email'
        },
        {
          label: 'Submissions',
          field: 'submissions'
        },
        {
          label: 'Status',
          field: 'status'
        },
        {
          label: 'Details',
          field: 'detailsUrl',
          width: '160px'
        }
      ],
      selectedGroupOrder: {},
      deletingRedemptionOrder: false
    }
  },
  methods: {
    ...mapActions('groupOrder', ['getGroupOrdersList', 'deleteGroupOrder']),
    currentState(state) {
      switch (state) {
        case 'locked':
          return 'Locked'
        case 'finalized':
          return 'Finalized'
        case 'auto_finalising':
          return 'Auto-finalizing'
        default:
          return 'Pending'
      }
    },
    pageChange(page) {
      this.updateParams({ page: page })
      this.getNextChuckOfGroupOrders()
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },
    handlePerPageChange(e) {
      this.serverParams.perPage = e
      this.getNextChuckOfGroupOrders()
    },
    getNextChuckOfGroupOrders() {
      this.getGroupOrdersList({
        page: this.serverParams.page + 1,
        perPage: this.serverParams.perPage,
        nameOrEmail: this.searchTerm,
        filter: 'active'
      })
    },
    // Search Group Order List
    searchGroupOrders(searchTerm) {
      this.getGroupOrdersList({
        page: this.serverParams.page + 1,
        perPage: this.serverParams.perPage,
        nameOrEmail: searchTerm,
        filter: 'active'
      })
    },
    handleShowDeleteModal(groupOrder) {
      this.selectedGroupOrder = groupOrder
      this.$store.dispatch('modal/showRemoveModal', this.deleteGroupOrderModal)
    },
    async confirmDeleteGroupOrder() {
      this.deletingRedemptionOrder = true
      try {
        await this.deleteGroupOrder(this.selectedGroupOrder.id)
        this.getNextChuckOfGroupOrders()
        this.$store.dispatch(
          'modal/hideRemoveModal',
          this.deleteGroupOrderModal
        )
        this.selectedGroupOrder = {}
      } catch (error) {
        return error
      } finally {
        this.deletingRedemptionOrder = false
      }
    }
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadGroupOrdersList)
    },
    ...mapState({
      loadGroupOrdersList: state => state.groupOrder.loadGroupOrdersList,
      groupOrdersList: state => state.groupOrder.groupOrdersList,
      searchTerm: state => state.globalTracking.searchTerm,
      currentSubscription: state => state.billing.currentSubscription,
      userProfile: state => state.profile.user,
      totalRecords: state => state.groupOrder.paginationTotalCount
    }),
    ...mapGetters({
      activeModals: 'modal/activeModals'
    }),
    isModalActive() {
      return this.activeModals(this.deleteGroupOrderModal)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.order-list {
  h1 {
    text-align: left;
  }
}
.gorder-list-submission {
  display: block;
  text-align: center;
}

.delete-button {
  &.isDisabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.gorder-list-submission,
.gorder-list-date {
  display: block;
  text-align: center;
}
.gorder-delete__info {
  margin: 0.6rem 0;
}
</style>
